import i18next from 'i18next'

/**
 * Uses a value and a currency code to create a currency-value string (e.g. 20,00€)
 * If currency code is valid it is used to determine the currency based on the ISO standard (ISO 4217)
 * If currency code is invalid (not known to the ISO standard) the code itself is used as the currency
 * @param value a monetary value
 * @param currencyCode a code (e.g. EUR) based on which the currency is determined
 * @param minimumFractionDigits allows removing the two default fraction digits when not showing tabular data
 * @returns a currency-value (e.g. 20,00€)
 */
export const getCurrencyValue = (value: number, currencyCode: string, minimumFractionDigits?: number): string => {
  try {
    return new Intl.NumberFormat(i18next.language, { style: 'currency', currency: currencyCode, minimumFractionDigits }).format(value)
  } catch (error) {
    const localValue = value.toFixed(2)
    return `${localValue} ${currencyCode}`
  }
}
